export default "__VITE_ASSET__BoCkOy0n__"